// frontend/src/components/HoursManagement/ProjectsTable.js

import React from 'react';
import DayHeader from './DayHeader';
import ProjectRow from './ProjectRow';
import { isWeekend, isFrenchHoliday } from '../../utils/dateUtils';
import { ChevronDown, ChevronRight } from 'lucide-react';

const ProjectsTable = ({
  weekDates,
  activeProjects, // Projets du slot auxquels l'utilisateur participe
  inactiveProjects, // Tous les autres projets
  showOtherProjects,
  setShowOtherProjects,
  getHours,
  handleHourChange,
  handleBlur,
  employee,
  getProjectTotal,
  getDayTotal,
  slotHoursByProject,
  plannedHoursByProject
}) => {
  const allProjects = [...activeProjects, ...inactiveProjects]; // Needed for totals calculation

  return (
    // --- MODIFICATION : Ajout du conteneur scrollable ---
    <div className="overflow-auto max-h-[70vh]">
      <table className="w-full">
        <thead>
          {/* --- MODIFICATION : Ajout des classes pour le sticky header --- */}
          <tr className="sticky top-0 z-10 bg-gray-50">
            <th className="px-4 py-2 text-left">Projets</th>
            {weekDates.map(date => (
              <DayHeader key={date.toISOString()} date={date} />
            ))}
            <th className="px-4 py-2 text-center">Total Semaine</th>
          </tr>
        </thead>

        <tbody>
          {/* Projets Actifs (Slot + Participant) */}
          {activeProjects.length === 0 ? (
             <tr>
                <td colSpan={weekDates.length + 2} className="px-4 py-3 text-center text-gray-500 italic">
                    Aucun projet actif pour vous dans ce slot.
                </td>
             </tr>
          ) : (
            activeProjects.map(project => (
              <ProjectRow
                key={project.id}
                project={project}
                weekDates={weekDates}
                getHours={getHours}
                handleHourChange={handleHourChange}
                handleBlur={handleBlur}
                employee={employee}
                getProjectTotal={getProjectTotal}
                slotTotalHours={slotHoursByProject[project.id] || 0}
                plannedHours={plannedHoursByProject[project.id] || 0}
              />
            ))
          )}

          {/* Section des Autres Projets */}
          {inactiveProjects.length > 0 && (
            <>
              <tr className="bg-gray-50 hover:bg-gray-100 cursor-pointer">
                <td colSpan={weekDates.length + 2}>
                  <button
                    onClick={() => setShowOtherProjects(!showOtherProjects)}
                    className="flex items-center w-full px-4 py-2 text-left text-sm font-medium text-gray-700"
                  >
                    {showOtherProjects ? (
                      <ChevronDown className="h-4 w-4 mr-2" />
                    ) : (
                      <ChevronRight className="h-4 w-4 mr-2" />
                    )}
                    Autres Projets ({inactiveProjects.length})
                     <span className="ml-2 text-xs text-gray-500 italic">(hors slot ou sans participation directe)</span>
                  </button>
                </td>
              </tr>
              {showOtherProjects && inactiveProjects.map(project => (
                <ProjectRow
                  key={project.id}
                  project={project}
                  weekDates={weekDates}
                  getHours={getHours}
                  handleHourChange={handleHourChange}
                  handleBlur={handleBlur}
                  employee={employee}
                  getProjectTotal={getProjectTotal}
                  slotTotalHours={slotHoursByProject[project.id] || 0}
                  plannedHours={plannedHoursByProject[project.id] || 0}
                />
              ))}
            </>
          )}
        </tbody>

        {/* --- MODIFICATION : Ajout des classes pour le sticky footer --- */}
        <tfoot className="sticky bottom-0 bg-gray-100 font-medium">
          <tr>
            <td className="px-4 py-2">Total</td>
            {weekDates.map(date => (
              <td
                key={date.toISOString()}
                className={`px-4 py-2 text-center ${
                  isWeekend(date) ? 'bg-gray-200' :
                  isFrenchHoliday(date) ? 'bg-gray-100' : ''
                }`}
              >
                {getDayTotal(date)}
              </td>
            ))}
            <td className="px-4 py-2 text-center">
              {allProjects.reduce((total, proj) => total + getProjectTotal(proj.id), 0)}
            </td>
          </tr>
        </tfoot>
      </table>

      {/* Légende */}
      <div className="mt-4 text-xs text-gray-500 flex items-center space-x-4">
        <div className="flex items-center">
          <div className="w-4 h-4 bg-gray-100 mr-2 border border-gray-200"></div>
          <span>Weekend</span>
        </div>
        <div className="flex items-center">
          <div className="w-4 h-4 bg-gray-50 mr-2 border border-gray-200"></div>
          <span>Jour férié</span>
        </div>
        <div className="flex items-center">
          <div className="w-4 h-4 bg-white border border-gray-300 mr-2"></div>
          <span>Jour ouvré</span>
        </div>
      </div>
    </div>
  );
};

export default ProjectsTable;